import React, { useEffect, useState } from 'react';
import { ButtonPrimary } from '@spotify-internal/encore-web';

export function SubmitButton(props: {
  isSubmitting: boolean;
  pristine: boolean;
}) {
  const { pristine, isSubmitting } = props;
  const [isActive, setIsActive] = useState(false);
  function getText() {
    if (isActive && isSubmitting) {
      return 'Saving...';
    }
    return 'Publish question';
  }

  useEffect(() => {
    if (!isSubmitting) {
      setIsActive(false);
    }
  }, [isSubmitting]);

  return (
    <ButtonPrimary
      type="submit"
      disabled={isSubmitting || pristine}
      onClick={() => {
        setIsActive(true);
      }}
    >
      {getText()}
    </ButtonPrimary>
  );
}
